export default {
  root: {},
  outlined: {
    fontSize: 12,
    transform: 'translate(14px, 17px) scale(1)',
    '&.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)',
    },
  },
  shrink: { transform: 'translate(14px, -6px) scale(0.75)' },
};
